/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { getStatusClass } from "../../../../../utils/utils";
export const StatusTypeFormatter = (cellContent, row, rowIndex) => {
  const { transactionStatus } = row;

  const renderStatus = () => {
    return (
      <span
        className={`${getStatusClass(
          transactionStatus
        )} status-color text-capitalize`}
      >
        {transactionStatus ? transactionStatus : "-"}
      </span>
    );
  };

  return (
    <span className="text-center text-dark-75 d-block">{renderStatus()}</span>
  );
};
